import AddNewPathModal from 'components/form_builder/modal/AddNewPathModal'
import ConfirmRemoveSectionModal from 'components/form_builder/modal/ConfirmRemoveSectionModal'
import React, { createContext, useCallback, useContext, useEffect, useRef, useState } from 'react'

const MenuDropdownContext = createContext()

const NewPath = ({ onSubmit }) => {
  const { isInteractingWithNestedModalRef } = useContext(MenuDropdownContext)
  const [openNewPathModal, setOpenNewPathModal] = useState(false)

  const handleOpenModal = () => {
    isInteractingWithNestedModalRef.current = true
    setOpenNewPathModal(true)
  }

  const handleCloseModal = () => {
    isInteractingWithNestedModalRef.current = false
    setOpenNewPathModal(false)
  }

  return (
    <>
      <li onClick={handleOpenModal} className="form-builder-section-menu-dropdown-item">
        <span className="dome-p1 dome-color-dark-grey dome-text-w300">+ new path</span>
      </li>
      <AddNewPathModal onSubmit={onSubmit} open={openNewPathModal} onClose={handleCloseModal} />
    </>
  )
}

const RemoveSection = ({ label = 'remove section', onSubmit }) => {
  const { isInteractingWithNestedModalRef } = useContext(MenuDropdownContext)
  const [confirmRemoveSectionModal, setConfirmRemoveSectionModal] = useState(false)

  const handleOpenModal = () => {
    isInteractingWithNestedModalRef.current = true
    setConfirmRemoveSectionModal(true)
  }

  const handleCloseModal = () => {
    isInteractingWithNestedModalRef.current = false
    setConfirmRemoveSectionModal(false)
  }

  return (
    <>
      <li onClick={handleOpenModal} className="form-builder-section-menu-dropdown-item dome-d-flex dome-flex-column">
        <span className="dome-p1 dome-color-red-alert dome-text-w300">{label}</span>
        <span className="dome-p3 dome-color-med-grey ">All paths will be unassigned</span>
      </li>
      <ConfirmRemoveSectionModal onSubmit={onSubmit} open={confirmRemoveSectionModal} onClose={handleCloseModal} />
    </>
  )
}

const MenuDropdownItem = ({ text, onClick }) => {
  return (
    <li onClick={onClick} className="form-builder-section-menu-dropdown-item">
      <span className="dome-p1 dome-color-dark-grey dome-text-w300">{text}</span>
    </li>
  )
}

const MenuDropdownTrigger = () => {
  const { handleOpen } = useContext(MenuDropdownContext)
  return (
    <div onClick={handleOpen} style={{ width: 15, height: 15 }}>
      <div className="dome-d-flex dome-align-center dome-justify-center dome-cursor-pointer">
        <i className="fa-light fa-ellipsis-vertical dome-color-dark-grey"></i>
      </div>
    </div>
  )
}

const MenuDropdownContent = ({ children }) => {
  const menuDropdownRef = useRef()
  const { openMenu, handleClose, isInteractingWithNestedModalRef } = useContext(MenuDropdownContext)

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        menuDropdownRef.current &&
        !menuDropdownRef.current.contains(e.target) &&
        !isInteractingWithNestedModalRef.current
      ) {
        handleClose()
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  if (!openMenu) return

  return (
    <div style={{ position: 'absolute', zIndex: 2, top: 0, right: -12 }}>
      <div ref={menuDropdownRef} className="form-builder-section-menu-dropdown">
        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
          {children}
          {/* conditional unavailable for now, just display */}
          <li className="form-builder-section-menu-dropdown-item">
            <span className="dome-p1 dome-color-lite-grey dome-text-w300">+ conditional</span>
          </li>
        </ul>
      </div>
    </div>
  )
}

export default function MenuDropdown({ open, onClose, children }) {
  const isInteractingWithNestedModalRef = useRef(false)

  const [openMenu, setOpenMenu] = useState(false)

  useEffect(() => {
    setOpenMenu(open)
  }, [open])

  const handleOpen = useCallback(() => setOpenMenu(true), [])
  const handleClose = useCallback(() => {
    setOpenMenu(false)
    onClose?.()
  }, [onClose])

  return (
    <MenuDropdownContext.Provider value={{ openMenu, handleOpen, handleClose, isInteractingWithNestedModalRef }}>
      <div className="dome-relative">{children}</div>
    </MenuDropdownContext.Provider>
  )
}

MenuDropdown.Item = MenuDropdownItem
MenuDropdown.NewPath = NewPath
MenuDropdown.RemoveSection = RemoveSection
MenuDropdown.Trigger = MenuDropdownTrigger
MenuDropdown.Content = MenuDropdownContent
